import { sessaoFetchLoading, sessaoFetch } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function getComissoes (dados) {
  return sessaoFetchLoading(`consig`, `/comissao_comercial/repassecomissoes`, 'PATCH', dados)
}
export async function getComissoesRelatorioVendedor (dados) {
  return sessaoFetchLoading(`consig`, `/comissao_comercial/RepasseComissoesRelatorioVendedor`, 'PATCH', dados)
}
export async function getTotalizadores (dados) {
  return sessaoFetchLoading(`consig`, `/comissao_comercial/Totalizadores?` + serialize(dados), 'GET')
}
export async function getLiberado (dados) {
  return sessaoFetchLoading(`consig`, `/comissao_comercial/GerarTotaisComissoesLiberadas?` + serialize(dados), 'GET')
}
export async function getTodosRepassesExportar (dados) {
  return sessaoFetchLoading(`consig`, `/comissao_comercial/ListarTodosExportar?` + serialize(dados), 'GET')
}
export async function pagarComissoes (comissoes) {
  return sessaoFetchLoading(`consig`, `/comissao_comercial/Pagar`, 'POST', comissoes)
}
export async function baixarComissoes (comissoes) {
  return sessaoFetchLoading(`consig`, `/comissao_comercial/Baixar`, 'POST', comissoes)
}
export async function extornarComissoes (comissoes) {
  return sessaoFetchLoading(`consig`, `/comissao_comercial/Extornar`, 'POST', comissoes)
}
export async function getRelatorioComissoesAssinaturas (ids) {
  return sessaoFetch(`consig`, `/comissao_comercial/ListarPorIds?ids=${ids.join('&ids=')}`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/repassecomissao.js